var LeftSectionMyProfile;

var ProfileImageContainer;
var LoadingBackgroundMyProfile;
var ProfilePictureBackgroundMyProfile;

var FirstNameContainer;
var FirstNameInput;
var FirstNameWarning;

var LastNameInputContainer;
var LastNameInput;
var LastNameWarning;

var GenderCheckBoxes;

var EmailInputContainer;
var EmailInput;
var EmailWarning;

var PhoneNumberContainer;
var CountryCodeContainer;
var CountryCodeText;
var PhoneNumberInput;
var PhoneNumberWarning;

var CountryDropDownContainer;
var CountryIcon;
var CountryText;
var CountryToggleArrow;
var CountryWarning;

var IDCardContainer;
var IDCardInput;
var IDCardWarning;

var ReferralContainer;
var ReferralInput;
var ReferralWarningContainer;
var ReferralWarningText;
var CheckReferralButton;
var CheckReferralButtonText;

var SaveChangesButton;

var IsEarlySetDone = false;

var FirstNamePast;
var LastNamePast;
var GenderSelectedPast;
var EmailPast;
var CountryCodePast;
var PhoneNumberPast;
var IDCardPast;
var IDReferralPast;

// var ReferralInputToSend = "";


// ============================ PREPARE UI MY PROFILE ===================================

window.PrepareUIMyProfile = function()
{
    document.getElementById("FirstNameHeaderTextMyProfile").innerHTML = window["FirstNameTxt" + window.CurrentCountryID];
    document.getElementById("FirstNameMyProfileInput").innerHTML = window["InputFirstNamePlaceholder" + window.CurrentCountryID];

    document.getElementById("LastNameHeaderTextMyProfile").innerHTML = window["LastNameTxt" + window.CurrentCountryID];
    document.getElementById("LastNameMyProfileInput").placeholder = window["InputLastNamePlaceholder" + window.CurrentCountryID];

    document.getElementById("GenderHeaderMyProfile").innerHTML = window["GenderHeaderTxt" + window.CurrentCountryID];
    document.getElementById("MaleCheckBoxTextMyProfile").innerHTML = window["GenderMaleTxt" + window.CurrentCountryID];
    document.getElementById("FemaleCheckBoxTextMyProfile").innerHTML = window["GenderFemaleTxt" + window.CurrentCountryID];

    document.getElementById("EmailHeaderTextMyProfile").innerHTML = window["EmailTxt" + window.CurrentCountryID];
    document.getElementById("EmailMyProfileInput").placeholder = window["InputFullNamePlaceholderTxt" + window.CurrentCountryID];

    document.getElementById("PhoneNumberHeaderTextMyProfile").innerHTML = window["PhoneNumberHeaderTxt" + window.CurrentCountryID];
    // document.getElementById("PhoneNumberMyProfileInput").placeholder = window["FirstNameTxt" + window.CurrentCountryID];

    document.getElementById("MyReferralCodeHeaderText").innerHTML = window["MyReferralCodeTxt" + window.CurrentCountryID];
    document.getElementById("ShareReferralBtnText").innerHTML = window["ShareReferralTxt" + window.CurrentCountryID];

    document.getElementById("CountryHeaderTextMyProfile").innerHTML = window["CountryHeaderTxt" + window.CurrentCountryID];

    document.getElementById("IDCardHeaderTextMyProfile").innerHTML = window["IDCardHeaderTxt" + window.CurrentCountryID];
    document.getElementById("IDCardMyProfileInput").placeholder = window["IDCardInputPlaceholder" + window.CurrentCountryID];

    document.getElementById("ReferralHeaderText").innerHTML = window["PunyaKodeRefHeaderTxt" + window.CurrentCountryID];
    document.getElementById("ReferralMyProfileInput").placeholder = window["InputReferralCodePlaceholderTxt2" + window.CurrentCountryID];
    document.getElementById("RefBottomMessage").innerHTML = window["GetDiscountMessageRefBottomTxt" + window.CurrentCountryID];

    document.getElementById("EditPhotoButtonText").innerHTML = window["EditPhotoButtonTxt" + window.CurrentCountryID];

    document.getElementById("SaveButtonText").innerHTML = window["SavedButtonTxt" + window.CurrentCountryID];
}

// ============================= SET PROFILE MENU INFO =========================================

window.SetMyProfileInput = function(thisuserdata, loggedin)
{
    if(loggedin == false)
        window.location.href = "/";

    let WhichPageSectionIsText = document.getElementById("WhichPageSectionIsText");
    WhichPageSectionIsText.innerHTML = window["ProfileTxt" + window.CurrentCountryID];

    if(IsEarlySetDone == false)
    {
        IsEarlySetDone = true;

        LeftSectionMyProfile = document.getElementById("LeftSectionMyProfile");

        ProfileImageContainer = document.getElementById("ProfileImageContainer");
        LoadingBackgroundMyProfile = document.getElementById("LoadingBackgroundMyProfile");
        ProfilePictureBackgroundMyProfile = document.getElementById("ProfilePictureBackgroundMyProfile");

        FirstNameContainer = document.getElementById("FirstNameMyProfileInputContainer");
        FirstNameInput = document.getElementById("FirstNameMyProfileInput");
        FirstNameWarning = document.getElementById("FirstNameMyProfileWarning");

        LastNameInputContainer = document.getElementById("LastNameMyProfileInputContainer");
        LastNameInput = document.getElementById("LastNameMyProfileInput");
        LastNameWarning = document.getElementById("LastNameMyProfileWarning");

        GenderCheckBoxes = document.querySelectorAll('[name="GenderMyProfileCheckBox"]');

        EmailInputContainer = document.getElementById("EmailMyProfileInputContainer");
        EmailInput = document.getElementById("EmailMyProfileInput");
        EmailWarning = document.getElementById("EmailMyProfileWarning");

        PhoneNumberContainer = document.getElementById("PhoneNumberMyProfileInputContainer");
        CountryCodeContainer = document.getElementById("MyProfileCountryCode");
        CountryCodeText = document.getElementById("MyProfileCountryCodeText");
        PhoneNumberInput = document.getElementById("PhoneNumberMyProfileInput");
        PhoneNumberWarning = document.getElementById("PhoneNumberMyProfileWarning");

        CountryDropDownContainer = document.getElementById("CountryPaymentFormDropDownContainer");
        CountryIcon = document.getElementById("CountryFlagPaymentFormIcon");
        CountryText = document.getElementById("CountryPaymentFormText");
        CountryToggleArrow = document.getElementById("CountryPaymentFormToggleArrow");
        CountryWarning = document.getElementById("CountryPaymentFormWarning");

        IDCardContainer = document.getElementById("IDCardMyProfileContainer");
        IDCardInput = document.getElementById("IDCardMyProfileInput");
        IDCardWarning = document.getElementById("IDCardMyProfileWarning");

        ReferralContainer = document.getElementById("ReferralMyProfileContainer");
        ReferralInput = document.getElementById("ReferralMyProfileInput");
        ReferralWarningContainer = document.getElementById("RedWarningReferralContainer");
        ReferralWarningText = document.getElementById("RedWarningReferralText");
        CheckReferralButton = document.getElementById("CheckReferralButton");
        CheckReferralButtonText = document.getElementById("CheckReferralButtonText");
        CheckReferralButtonText.innerHTML = window["AddReferralBtnTxt" + window.CurrentCountryID];

        SaveChangesButton = document.getElementById("SaveChangesButton");
    }


    // ------------------------------ ASIGN INFO -----------------------------------------------

    let LoadUserTopBlocker = window.InstantiateLoadingBlocker("LoadUserTopBlocker");
    
    let ProfileUserURL = "/v2/profile/" + thisuserdata.usd_PING_id + "?token=" + thisuserdata.usd_PING_tkn;

    window.CallApiAxios({
        method: "GET",
        url: ProfileUserURL,
    })
    .then(res =>
    {
        //console.log(ProfileUserURL);
        //console.log(res);

        if(res.status == 200)
        {
            let ThisUserData = res.data.data;
            //console.log(ThisUserData);

            LoadUserTopBlocker.remove();

            // Profile Picture ------------------------------------------

            let ImageToLoad = ThisUserData.member_pings.profile_picture;

            LoadingBackgroundMyProfile.style.opacity = 1;

            let LoadingGreyUserProfile = document.createElement("div");
            LoadingGreyUserProfile.className = "loading_grey ImageFullCover";
            ProfileImageContainer.append(LoadingGreyUserProfile);

            let ProfilePictureMyProfile = document.createElement("img");
            ProfilePictureMyProfile.className = "ImageFullCover";
            ProfilePictureMyProfile.style.opacity = 0;
            ProfileImageContainer.append(ProfilePictureMyProfile);

            window.checkImageUrlValid(ImageToLoad, "/Assets/images/ProfilePicture.jpg", ProfilePictureMyProfile, () =>
            {
                window.checkImageUrlValid(ImageToLoad, "/Assets/images/ProfilePicture.jpg", ProfilePictureBackgroundMyProfile, () =>
                {
                    window.CheckIfImageLoadedAndCallAFunction(LeftSectionMyProfile, ()=>
                    {
                        LoadingGreyUserProfile.remove();
                        LoadingBackgroundMyProfile.style.opacity = 0;

                        ProfilePictureMyProfile.style.opacity = 1;
                        ProfilePictureBackgroundMyProfile.style.opacity = 1;
                    });
                }, {});
            }, {});



            // Fist Name ------------------------------------------
            FirstNameInput.value = ThisUserData.first_name;
            FirstNamePast = ThisUserData.first_name;

            // Last Name ------------------------------------------
            LastNameInput.value = ThisUserData.last_name;
            LastNamePast = ThisUserData.last_name;

            // Gender ------------------------------------------
            let WhatGender = "Female";
            if(ThisUserData.gender == "" || ThisUserData.gender == null || ThisUserData.gender == "Male" || ThisUserData.gender == "Pria")
                WhatGender = "Male";

            GenderCheckBoxes.forEach(CheckBox =>
            {
                if(CheckBox.value == WhatGender)
                {
                    CheckBox.checked = true;
                }
                else
                {
                    CheckBox.checked = false;
                }
                CheckBox.onclick = function()
                {
                    CheckInputtedNewProfile(true, thisuserdata.usd_PING_id, thisuserdata.usd_PING_tkn);
                }
            });
            GenderSelectedPast = WhatGender;

            // Email ------------------------------------------
            EmailInput.value = ThisUserData.email;
            EmailPast = ThisUserData.email;

            // Country Code ------------------------------------------
            let ThisUserCountryCode = ThisUserData.country_code;
            if(ThisUserData.country_code == null)
                ThisUserCountryCode = 62;

            CountryCodeContainer.setAttribute("country-code", ThisUserCountryCode);
            CountryCodeText.innerHTML = "+" + ThisUserCountryCode;
            CountryCodePast = ThisUserCountryCode;

            // Phone Number ------------------------------------------
            PhoneNumberInput.value = ThisUserData.phone_number;
            PhoneNumberInput.setAttribute("previous-input", ThisUserData.phone_number);
            PhoneNumberPast = ThisUserData.phone_number;

            if(ThisUserData.phone_number == null || ThisUserData.phone_number == "")
            {
                PhoneNumberContainer.className = "SmallPanelDropDownContainer";
                PhoneNumberContainer.style.pointerEvents = "";
                PhoneNumberInput.readOnly = false;
            }
            else
            {
                PhoneNumberContainer.className = "SmallPanelDropDownContainer InputFieldContainerInvalid";
                PhoneNumberContainer.style.pointerEvents = "none";
                PhoneNumberInput.readOnly = true;
            }

            // Country ------------------------------------------
            let SelectedCountry = ThisUserData.country;
            if(SelectedCountry == "" || SelectedCountry)
            {
                SelectedCountry = "Indonesia";
            }

            if(SelectedCountry)
            {
                for(let i = 0; i < window.CountryListCode.length; i++)
                {
                    if(SelectedCountry == window.CountryListCode[i].CountryName)
                    {
                        CountryIcon.src = window.CountryListCode[i].FlagIcon;
                        CountryText.innerHTML = window.CountryListCode[i].CountryName;
                        CountryDropDownContainer.setAttribute("country-selected", window.CountryListCode[i].CountryName);
                        CountryDropDownContainer.setAttribute("original-country", ThisUserData.country);
                    }
                }
            }


            // ID Card ------------------------------------------
            IDCardInput.value = ThisUserData.ktp_passport;
            IDCardInput.setAttribute("previous-input", ThisUserData.ktp_passport);
            IDCardPast = ThisUserData.ktp_passport;

            if(ThisUserData.ktp_passport == null || ThisUserData.ktp_passport == "")
            {
                IDCardContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
                IDCardContainer.style.pointerEvents = "";
                IDCardInput.readOnly = false;
            }
            else
            {
                IDCardContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
                IDCardContainer.style.pointerEvents = "none";
                IDCardInput.readOnly = true;
            }

            // My Referral ---------------------------------------

            document.getElementById("MyReferralCodeMyProfileContainer").style.display = "";
            document.getElementById("MyReferralCodeText").innerHTML = ThisUserData.member_pings.id_referral;
            document.getElementById("CopyReferralButton").onclick = function()
            {
                window.CopyToClipboardItem(ThisUserData.member_pings.id_referral);
            }
            document.getElementById("ShareReferralButtonMyPage").onclick = function()
            {
                // Function To Call For Prepare And Send Referral --------------------------

                let FunctionToCall = ()=>
                {
                    window.InstantiateSharePanel("Share Referral", "Ask to Join PinginGo", "Share Referral Success", "Referral", '', '', '', loggedin);
                }
                
                let PushCreatedShareURL = "/function/upload_referral_img.php";

                window.ShareURL = ThisUserData.member_pings.id_referral;

                let formData = new FormData();
                formData.append('id_referral', ThisUserData.member_pings.id_referral);

                window.CheckShareImageExist(ProfileUserURL, "/Assets/Ref-PinginGo.jpg", PushCreatedShareURL, "UserReferral", formData, FunctionToCall);
            }

            // Referral ------------------------------------------
            if(ThisUserData.member_pings.id_referral_used == null)
            {
                ReferralInput.value = "";
                ReferralInput.readOnly = false;
                ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
                CheckReferralButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop ButtonUnselectable";

                ReferralInput.onfocus = function(event)
                {
                    ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
                    ReferralWarningContainer.className = "BasicRoundRadius MarginTextUpDown RedWarningContainer WarningTextMarginTop WarningTopMyProfileHide";
                    CheckReferralButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop ButtonUnselectable";

                }
                ReferralInput.addEventListener("focusout", (event) =>
                {
                    if(ReferralInput.value == ""  || ReferralInput.value.replace(/ /g, "") == "")
                    {
                        CheckReferralButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop ButtonUnselectable";
                    }
                    else
                    {
                        CheckReferralButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop Selectable";
                    }
                });
                CheckReferralButton.onclick = function()
                {
                    let formDataCheckReferral = new FormData();
                    formDataCheckReferral.append('lang', window.CurrentCountryID);
                    formDataCheckReferral.append('token', thisuserdata.usd_PING_tkn);

                    ConfirmAreYouSureYouWantToApplyRef(ReferralInput, formDataCheckReferral, thisuserdata);
                    // CheckInputtedReferral(formDataCheckReferral, thisuserdata.usd_PING_id);
                }
            }
            else
            {
                ReferralInput.value = ThisUserData.member_pings.id_referral_used;
                ReferralInput.readOnly = true;
                ReferralContainer.style.pointerEvents = "none";
                ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
                CheckReferralButton.className = "BasicTextButton BasicBoxShadow AddReferralButtonSuccess SignInButtonTop";
                CheckReferralButtonText.innerHTML = window["ReferralVerifiedTxt" + window.CurrentCountryID];
                CheckReferralButton.onclick = function(){};
            }

            //--------------------------------- ADD FUNCTION ---------------------------------------------

            FirstNameInput.onfocus = function(event) // First Name --------------
            {
                FirstNameContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
                FirstNameWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
                SaveChangesButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
            }
            FirstNameInput.addEventListener("focusout", (event) =>
            {
                CheckInputtedNewProfile(true, thisuserdata.usd_PING_id, thisuserdata.usd_PING_tkn);
            });


            LastNameInput.onfocus = function(event) // Last Name --------------
            {
                LastNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
                LastNameWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
                SaveChangesButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
            }
            LastNameInput.addEventListener("focusout", (event) =>
            {
                CheckInputtedNewProfile(true, thisuserdata.usd_PING_id, thisuserdata.usd_PING_tkn);
            });


            EmailInput.onfocus = function(event) // Email --------------
            {
                EmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
                EmailWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
                SaveChangesButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
            }
            EmailInput.addEventListener("focusout", (event) =>
            {
                CheckInputtedNewProfile(true, thisuserdata.usd_PING_id, thisuserdata.usd_PING_tkn);
            });


            CountryCodeContainer.onclick = function() // Country Code --------------
            {
                window.OpenCountryCode(CountryCodeContainer, CountryCodeText, "MyProfile", ()=> CheckInputtedNewProfile(true, thisuserdata.usd_PING_id, thisuserdata.usd_PING_tkn));
            }


            PhoneNumberInput.onfocus = function(event) // Phone Number --------------
            {
                PhoneNumberContainer.className = "SmallPanelDropDownContainer";
                PhoneNumberWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
                SaveChangesButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
            }
            PhoneNumberInput.addEventListener("focusout", (event) =>
            {
                if(PhoneNumberInput.getAttribute("previous-input") != PhoneNumberInput.value)
                {
                    PhoneNumberInput.setAttribute("previous-input", PhoneNumberInput.value);
                    PhoneNumberInput.setAttribute("is-change", 'true');
                }
                CheckInputtedNewProfile(true, thisuserdata.usd_PING_id, thisuserdata.usd_PING_tkn);
            });


            CountryDropDownContainer.onclick = function() // Country --------------
            {
                window.OpenCountryChoice(CountryDropDownContainer, CountryIcon, CountryText, "CountryPaymentFormToggleArrow", "PaymentForm", ()=> CheckInputtedNewProfile(true, thisuserdata.usd_PING_id, thisuserdata.usd_PING_tkn));
            }


            IDCardInput.onfocus = function(event) // ID Card --------------
            {
                IDCardContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
                IDCardWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
                SaveChangesButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
            }
            IDCardInput.addEventListener("focusout", (event) =>
            {
                if(IDCardInput.getAttribute("previous-input") != IDCardInput.value)
                {
                    IDCardInput.setAttribute("previous-input", IDCardInput.value);
                    IDCardInput.setAttribute("is-change", 'true');
                }
                CheckInputtedNewProfile(true, thisuserdata.usd_PING_id, thisuserdata.usd_PING_tkn);
            });

            SaveChangesButton.onclick = function(){};
            
            CheckInputtedNewProfile(false, thisuserdata.usd_PING_id, thisuserdata.usd_PING_tkn);

            // EDit Image Button ------------------------------------------------------------

            document.getElementById("EditPhotoMyProfileButton").className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
            document.getElementById("EditPhotoMyProfileButton").onclick = function()
            {
                window.InstantiateEditPhotoPanel(thisuserdata.usd_PING_id, thisuserdata.usd_PING_tkn);
            }
        }
    })
    .catch(err =>
    {
        //console.error(err);
        LoadUserTopBlocker.remove();
        window.LogOutUserFunction(thisuserdata.usd_PING_tkn, false);
    });
}

// ================================== CHECK INPUT PROFILE =================================

function CheckInputtedNewProfile(isallowchange, thisuserid, thistoken)
{
    let IsError = false;
    let IsNew = false;

    // First Name -------------------------------------------------------------
    if(FirstNameInput.value == ""  || FirstNameInput.value.replace(/ /g, "") == "")
    {
        IsError = true;
        if(isallowchange == true)
        {
            FirstNameContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            FirstNameWarning.className = "RedWarningText InterMediumTextFont";
            FirstNameWarning.innerHTML = window["FirstNameCannotEmpty" + window.CurrentCountryID];
        }
    }

    // Phone Number -------------------------------------------------------------
    if(PhoneNumberInput.value == ""  || PhoneNumberInput.value.replace(/ /g, "") == "")
    {
        IsError = true;
        if(isallowchange == true)
        {
            PhoneNumberContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";
            PhoneNumberWarning.className = "RedWarningText InterMediumTextFont";
            PhoneNumberWarning.innerHTML = window["PhoneNumberCannotEmpty" + window.CurrentCountryID];
        }
    }
    else if(PhoneNumberInput.getAttribute("is-change") == "true")
    {
        PhoneNumberInput.setAttribute("is-change", "false");

        window.CheckPhoneNumberAlreadyUsed(thisuserid, CountryCodeContainer.getAttribute("country-code"), PhoneNumberInput.value, true, function(result, reasoninvalid)
        {
            if(result == false)
            {
                IsError = true;
                if(isallowchange == true)
                {
                    PhoneNumberContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";
                    PhoneNumberWarning.className = "RedWarningText InterMediumTextFont";
                    PhoneNumberWarning.innerHTML = window["PhoneNumberInvalidTxt" + window.CurrentCountryID];
                    //console.log(reasoninvalid);
                    if(reasoninvalid == "Already Used" || reasoninvalid == "Already used")
                    {
                        PhoneNumberWarning.innerHTML = window["PhoneNumberAlreadyUsedTxt" + window.CurrentCountryID];
                    }
                }
                SaveChangesButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
            }
        });
    }

    
    // ID Card -------------------------------------------------------------
    if(IDCardInput.value == ""  || IDCardInput.value.replace(/ /g, "") == "")
    {
        IsError = true;
        if(isallowchange == true)
        {
            IDCardContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            IDCardWarning.className = "RedWarningText InterMediumTextFont";
            IDCardWarning.innerHTML = window["IDCardCannotBeUsed" + window.CurrentCountryID];
        }
    }
    else if(IDCardInput.getAttribute("is-change") == "true")
    {
        IDCardInput.setAttribute("is-change", 'false');

        window.CheckIDCardUsed(thisuserid, IDCardInput.value, true, function(result, reasoninvalid)
        {
            if(result == false)
            {
                IsError = true;
                //console.log("reasoninvalid == " + reasoninvalid);

                if(isallowchange == true)
                {
                    IDCardContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
                    IDCardWarning.className = "RedWarningText InterMediumTextFont";
                    IDCardWarning.innerHTML = window["IDCardCannotBeUsed" + window.CurrentCountryID];
                    if(reasoninvalid == "Already Used" || reasoninvalid == "Already used")
                    {
                        IDCardWarning.innerHTML = window["IDCardAlreadyUsedTxt" + window.CurrentCountryID];
                    }
                }
                SaveChangesButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
            }
        });
    }

    // Gender --------------------------------------------------------------

    let GenderCurrentlyChecked;
    GenderCheckBoxes.forEach(CheckBox =>
    {
        if(CheckBox.checked == true)
        {
            GenderCurrentlyChecked = CheckBox.value;
        }
    });

    if(FirstNameInput.value != FirstNamePast || LastNameInput.value != LastNamePast || GenderCurrentlyChecked != GenderSelectedPast ||
        CountryCodeContainer.getAttribute("country-code") != CountryCodePast || PhoneNumberInput.value != PhoneNumberPast ||
        IDCardInput.value != IDCardPast || CountryDropDownContainer.getAttribute("original-country") == "" || PhoneNumberInput.getAttribute("previous-input") == "" ||
        IDCardInput.getAttribute("previous-input") == "")
    {
        IsNew = true;
    }

    if(IsNew == false || IsError == true)
    {
        SaveChangesButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
        SaveChangesButton.onclick = function(){};
    }
    else
    {
        SaveChangesButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
        SaveChangesButton.onclick = function()
        {
            PrepareToUpdateUserProfile(thisuserid, thistoken)
        }
    }

}


// ================================== UPDATE USER PROFILE =======================================

async function PrepareToUpdateUserProfile(thisuserid, thistoken)
{
    let PushUserLoadingBlocker = window.InstantiateLoadingBlocker("PushUserLoadingBlocker");

    let GenderCurrentlyChecked;
    GenderCheckBoxes.forEach(CheckBox =>
    {
        if(CheckBox.checked == true)
        {
            GenderCurrentlyChecked = CheckBox.value;
        }
    });

    let formData = new FormData();
    formData.append("first_name", FirstNameInput.value);
    formData.append("last_name", LastNameInput.value);
    formData.append("gender", GenderCurrentlyChecked);
    formData.append("country_code", CountryCodeContainer.getAttribute("country-code"));
    formData.append("phone_number", PhoneNumberInput.value);
    formData.append("country", CountryDropDownContainer.getAttribute("country-selected"));
    formData.append("id_card", IDCardInput.value);
    formData.append("token", thistoken);
    await window.getBrowserData(formData);
    //console.log(window.ConvertFormDataToJSON(formData));
    
    // Function to Call if Success -------------------------------------------------------------------
    let functiontocallsuccess = function()
    {
        if(sessionStorage.getItem("IM_Ping_INFO") != null) // Remove and Reload Data --------------------------
        sessionStorage.removeItem("IM_Ping_INFO");

        if(sessionStorage.getItem("U_Ping_INFO") != null)
            sessionStorage.removeItem("U_Ping_INFO");

        window.CheckUserInfoExist(false);

        ReferralWarningContainer.className = "BasicRoundRadius MarginTextUpDown RedWarningContainer WarningTextMarginTop GreenWarningContainer";

        window.ScrollToWindow(document.getElementById("TopCornerButtonContainer"));

        PushUserLoadingBlocker.remove();
    }

    // Function to Call if Error -------------------------------------------------------------------
    let functiontocallerror = function()
    {
        ReferralWarningContainer.className = "BasicRoundRadius MarginTextUpDown RedWarningContainer WarningTextMarginTop";

        window.ScrollToWindow(document.getElementById("TopCornerButtonContainer"));

        PushUserLoadingBlocker.remove();
    }


    window.UpdateUserProfile(thisuserid, formData, ReferralWarningText, ()=>functiontocallsuccess(), ()=>functiontocallerror());
}

// ====================================== CHECK REFERRAL =========================================

function ConfirmAreYouSureYouWantToApplyRef(ReferralInput, formDataCheckReferral, thisuserdata)
{
    let InputtedReferral = ReferralInput.value;
    formDataCheckReferral.append('id_referral', InputtedReferral);

    // ========================== ARE YOU SURE ===========================
    
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    FlexFullDisplayPanel.style = "padding: 0; overflow-y: visible; max-height: none;";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    let ConfirmReferralContainer = document.createElement("div");
    ConfirmReferralContainer.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    ConfirmReferralContainer.style.padding = 0;
    FlexFullDisplayPanel.append(ConfirmReferralContainer);

    let ConfirmReferralTopContainer = document.createElement("div"); // Top Header and Close Button ------------------------
    ConfirmReferralTopContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow";
    ConfirmReferralContainer.append(ConfirmReferralTopContainer);

    let ConfirmReferralTopWrapper = document.createElement("div");
    ConfirmReferralTopWrapper.style="flex: 1; height: fit-content; display: flex; position: relative;"
    ConfirmReferralTopContainer.append(ConfirmReferralTopWrapper);

    let ConfirmReferralTopText = document.createElement("p");
    ConfirmReferralTopText.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    ConfirmReferralTopText.style = "margin: auto;";
    ConfirmReferralTopText.innerHTML = window["UseReferralCodeBtnTxt" + window.CurrentCountryID];
    ConfirmReferralTopWrapper.append(ConfirmReferralTopText);

    let ConfirmReferralCancelButton = document.createElement("img");
    ConfirmReferralCancelButton.className = "CloseButtonInsidePanel Selectable2";
    ConfirmReferralCancelButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    ConfirmReferralCancelButton.style = "position: absolute; right: 0; top: 50%; transform: translateY(-50%)";
    ConfirmReferralCancelButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    ConfirmReferralTopWrapper.append(ConfirmReferralCancelButton);


    let ConfirmReferralMainContainer = document.createElement("div"); // Main Content Section -------------------------
    ConfirmReferralMainContainer.className = "FlexFullDisplayPanel";
    ConfirmReferralMainContainer.style = "width: 100%; z-index: 0; box-sizing: border-box;";
    ConfirmReferralContainer.append(ConfirmReferralMainContainer);

    let ConfirmReferralMainPadder = document.createElement("div");
    ConfirmReferralMainPadder.className = "FlexFullDisplayPanel";
    ConfirmReferralMainContainer.append(ConfirmReferralMainPadder);

    let ConfirmReferralAlertWrapper = document.createElement("div"); // Alert Icon
    ConfirmReferralAlertWrapper.className = "AllContentMarginPayment";
    ConfirmReferralAlertWrapper.style.display = "flex";
    ConfirmReferralAlertWrapper.style.flexDirection = "column";
    ConfirmReferralMainPadder.append(ConfirmReferralAlertWrapper);

    let ConfirmReferralAlertIMG = document.createElement("img");
    ConfirmReferralAlertIMG.className = "BigIconInsidePanel4";
    ConfirmReferralAlertIMG.src = "/Assets/images/Icon/gunakan-code-referral-icon.svg";
    ConfirmReferralAlertIMG.style = "margin: 0 auto;";
    ConfirmReferralAlertWrapper.append(ConfirmReferralAlertIMG);

    let ThisReferralContainer = document.createElement("div"); // Alert Icon
    ThisReferralContainer.className = "ReferralCodeAreYouSureContainer BasicRoundRadius";
    ConfirmReferralAlertWrapper.append(ThisReferralContainer);

    let ThisReferralText = document.createElement("p");
    ThisReferralText.className = "LabelGreyHeaderSmallerText2 MarginTextUpDown InterMediumTextFont";
    ThisReferralText.style = "width: fit-content;";
    ThisReferralText.style.margin = "auto";
    ThisReferralText.style.color = "#667085";
    ThisReferralText.innerHTML = InputtedReferral;
    ThisReferralContainer.append(ThisReferralText);
    

    let ConfirmReferralHeaderText = document.createElement("p"); // Header and Message ------------------------------------
    ConfirmReferralHeaderText.className = "LabelGreyHeaderText MarginTextUpDown InterBoldTextFont";
    ConfirmReferralHeaderText.style = "width: fit-content; margin: 0 auto;";
    ConfirmReferralHeaderText.innerHTML = window["ConfirmationReferralHeaderTxt" + window.CurrentCountryID];
    ConfirmReferralMainPadder.append(ConfirmReferralHeaderText);

    let ConfirmReferralMessageText = document.createElement("p");
    ConfirmReferralMessageText.className = "DescriptionTextNotDisableable LabelGreyHeaderSmallerText2 MarginTextUpDown InterRegularTextFont";
    ConfirmReferralMessageText.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    ConfirmReferralMessageText.style.marginTop = 0;
    ConfirmReferralMessageText.innerHTML = window["DoYouProceedUseThisReferralTxt" + window.CurrentCountryID];
    ConfirmReferralMainPadder.append(ConfirmReferralMessageText);



    let ButtonWrapper  = document.createElement("div"); // Button ---------
    ButtonWrapper.className = "MoreThanOneButtonFlexWrapper ResendChangeEmailButtonWrapper";
    ButtonWrapper.style.marginBottom = 0;
    ConfirmReferralMainPadder.append(ButtonWrapper);

    let ContinueButton  = document.createElement("button"); // Continue Payment -----------
    ContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    ContinueButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
        PrepareToUpdaterReferral(formDataCheckReferral, thisuserdata);
    }
    ButtonWrapper.append(ContinueButton);

    let ContinueButtonWrapper = document.createElement("div");
    ContinueButtonWrapper.style = "width: fit-content; height: fit-content; display: flex; margin: auto;";
    ContinueButton.append(ContinueButtonWrapper);

    let ContinueButtonIcon = document.createElement("img");
    ContinueButtonIcon.className = "BasicIconInsideButton2";
    ContinueButtonIcon.src = "/Assets/images/ButtonIcon/check-circle-white.svg";
    ContinueButtonIcon.style.marginLeft = 0;
    ContinueButtonWrapper.append(ContinueButtonIcon);

    let ContinueButtonText= document.createElement("p");
    ContinueButtonText.innerHTML = window["UseReferralCodeBtnTxt" + window.CurrentCountryID];
    ContinueButtonWrapper.append(ContinueButtonText);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}


function PrepareToUpdaterReferral(thisformdata, thisuserdata)
{
    let LoadingBlocker = window.InstantiateLoadingBlocker("UpdateReferralBlocker");

    let functionifsuccess = function() // Function Success -----------------------------------------
    {
        LoadingBlocker.remove();

        ReferralWarningContainer.className = "BasicRoundRadius MarginTextUpDown RedWarningContainer WarningTextMarginTop GreenWarningContainer";

        ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
        ReferralInput.readOnly = true;

        CheckReferralButton.className = "BasicTextButton BasicBoxShadow AddReferralButtonSuccess SignInButtonTop";
        CheckReferralButton.onclick = function(){};
        CheckReferralButtonText.innerHTML = window["ReferralVerifiedTxt" + window.CurrentCountryID];

        // if(sessionStorage.getItem("IM_Ping_INFO") != null)
        //     sessionStorage.removeItem("IM_Ping_INFO");

        // if(sessionStorage.getItem("U_Ping_INFO") != null)
        //     sessionStorage.removeItem("U_Ping_INFO");

        window.CheckUserInfoExist(false);

        window.ScrollToWindow(document.getElementById("TopCornerButtonContainer"));
    }

    let functioniferror = function() // Function Error -------------------------------------------------
    {
        LoadingBlocker.remove();

        ReferralWarningContainer.className = "BasicRoundRadius MarginTextUpDown RedWarningContainer WarningTextMarginTop";
        window.ScrollToWindow(document.getElementById("TopCornerButtonContainer"));
    }

    window.UpdateReferralOnly(thisformdata, thisuserdata.usd_PING_id, ReferralWarningText, ()=>functionifsuccess(), ()=>functioniferror());
}

